import { makeResponsiveTable } from '../../functions/makeResponsiveTable';
export default function responsiveTable() {
    const responsiveWrappers = document.querySelectorAll('[data-responsive-table]');
    responsiveWrappers?.forEach((wrapper) => {
        makeResponsiveTable(wrapper);
    });
}
responsiveTable();
//# sourceMappingURL=responsive-table.js.map